var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEditMode)?_c('sc-image',{attrs:{"media":_vm.mainImage,"editable":_vm.editable}}):_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.mainImage.src),expression:"mainImage.src"}],attrs:{"alt":_vm.mainImage.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }